export default __webpack_public_path__ + "c7c5e90668a7fa3ed837509cdeba2490.png";